// extracted by mini-css-extract-plugin
export default {"text_container":"login-page_text_container__L3Tcm","button_reset":"login-page_button_reset__SaoZE"};